var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" Your application was submitted successfully! We will get in touch with you if we require any further information. ")]),_c('p')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }